import updateTestDateService from "./updateTestDateService";

const testDateService = [
    ...updateTestDateService
];

export { testDateService as default, updateTestDateService }